import React from 'react';
import styled from 'styled-components';

import { hexToRGBA } from '../../../lib/colors';

const StyledWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(props) => props.borderRadius}px;
  ${(props) => (!props.disabled ? `background: ${props.backgroundColor};` : '')}
  &:hover {
    ${(props) => (!props.disabled ? 'cursor: pointer;' : '')}
    ${(props) => (!props.disabled ? `background-color: ${props.backgroundColor};` : '')}
    ${(props) => (!props.disabled ? `border: 1px solid ${props.primaryColor};` : '')}
  }
`;

const StyledValue = styled.div`
  height: 100%;
  width: 100%;
  font-size:${(props) => props.fontSize}px !important;
  color: ${(props) => props.fontColor};
  font-style: ${(props) => props.fontStyle};
  font-weight: ${(props) => props.fontWeight};
  text-align: ${(props) => props.textAlign};
  text-transform: ${(props) => props.textTransform};
  text-decoration: ${(props) => props.textDecoration};
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius}px;
  border: ${(props) => props.border};
  padding: ${(props) => props.padding}px;
  ${(props) => (props.textOverflow ? `text-overflow: ${props.textOverflow};` : '')}
  ${(props) => (props.textOverflow === 'ellipsis' ? 'overflow: hidden;' : '')}
  ${(props) => (props.textOverflow === 'ellipsis' ? 'white-space: nowrap;' : '')}
`;

function TextSelectionField({

  id,
  disabled,

  value,
  trueDisplayValue,
  falseDisplayValue,

  //Field style
  fontSize,
  fontColor,
  fontStyle,
  fontWeight,
  textAlign,
  textTransform,
  textDecoration,
  textOverflow,
  borderColor,
  borderRadius,
  borderWidth,
  backgroundColor,
  padding,
  primaryColor,
  //Action handlers
  onChange,
  onFocus,

}) {

  /**
   * We join width and color to a single border style because chrome displays
   * the border as a two tone color if you use border-color and border-width
   * indvidually.
   */
  const border = `${borderWidth}px solid ${borderColor}`;

  const styleProps = {
    border,
    borderRadius,
    backgroundColor,
    padding,
    fontSize,
    fontColor,
    fontStyle,
    fontWeight,
    textAlign,
    textTransform,
    textDecoration,
    textOverflow,
  };

  return (
    <StyledWrapper
      {...{
        primaryColor,
        borderRadius,
        backgroundColor: hexToRGBA(primaryColor, '0.15'),
      }}
      disabled={disabled}
      data-testid={`${id}-text-selection-field`}
      onClick={() => {
        if (onFocus) onFocus();
        if (!disabled && onChange) onChange(!value);
      }}
    >
      {value && trueDisplayValue ? (
        <StyledValue {...styleProps}>{trueDisplayValue}</StyledValue>
      ) : null}
      {!value && falseDisplayValue ? (
        <StyledValue {...styleProps}>{falseDisplayValue}</StyledValue>
      ) : null}
    </StyledWrapper>
  );
}

export default React.memo(TextSelectionField);
